import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DialogForRejectedReason from "./DialogForRejectedReason";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import LoadingSpinnerWithText from "../../components/ui/LoadingSpinnerWithText";
import { getRejectionReason } from "../../Store/Ducks/duckAccountRejectionReason";

function DialogContainerForRejectedReason({
  showDialog,
  closeDialog,
  selectedRowData = {},
}) {
  const [loading, setLoading] = useState(true);
  const [rejectionReasonData, setRejectionReasonData] = useState(null);
  const dispatch = useDispatch();
  // rejectionReasonData = useSelector(store => store.accountRejectionReason?.data) || [];

  useEffect(() => {
    dispatch(getRejectionReason(selectedRowData.guiD_OPERATION))
      .then((response) => {
        setRejectionReasonData(response.payload.data);
      })
      .catch((error) => {
        if (error.response.status === 404) {
          setRejectionReasonData(null);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  const displayTitle = () => {
    return (
      <>
        Motivos de Rechazo
        {selectedRowData && (
          <Typography>
            <Box component="span" sx={{ fontWeight: 600 }}>
              {"#Factura: "}
            </Box>
            {selectedRowData?.reference}
          </Typography>
        )}
      </>
    );
  };

  const displayContent = () => {

    if (!rejectionReasonData) {
      return (
        <Typography variant="body2">{"No se encontraron motivos de rechazo"}</Typography>
      )
    }

    return (
      <Stack spacing={2}>
        <Box>
          <Typography variant="body2">{"Razón: "}</Typography>
          <Typography variant="body2">{rejectionReasonData?.reason}</Typography>
        </Box>
        <Box>
          <Typography variant="body2">{"Comentarios: "}</Typography>
          <Typography variant="body2">
            {rejectionReasonData?.comment
              ?.replace(/<div[^>]*>/, "")
              .replace(/<\/div>/, "")}
          </Typography>
        </Box>
      </Stack>
    );
  };

  return (
    <DialogForRejectedReason
      open={showDialog}
      handleClose={closeDialog}
      dialogTitle={displayTitle()}
      dialogContentWidth={"500px"}
      dialogContentMinHeight={"100px"}
    >
      {loading ? (
        <LoadingSpinnerWithText
          textToDisplay="Buscando información..."
          marginTop="20px"
        />
      ) : (
        displayContent()
      )}
    </DialogForRejectedReason>
  );
}

export default DialogContainerForRejectedReason;
